function isJsonString(str) {
    try {
        return JSON.parse(str);
    }
    catch (err) {
        return false;
    }
}
export default isJsonString;
//# sourceMappingURL=isJsonString.js.map